import { getDeadlineField } from '../deadlineResultPresentation'

function uniqueItems(items) {
  return [...new Set(items.map((item) => String(item || '').trim()).filter(Boolean))]
}

export default function DeadlineHumanReviewBanner({ result, reasons = [], shouldShow = false, calculatedWithReview = false }) {
  if (!shouldShow) return null

  const reviewReasons = uniqueItems([
    ...getDeadlineField(getDeadlineField(result, 'reviewDecision'), 'reasons', [])
      .map(reason => getDeadlineField(reason, 'message')),
    getDeadlineField(result, 'reviewReason'),
    ...(calculatedWithReview
      ? [...getDeadlineField(result, 'interpretedActions', []), ...getDeadlineField(result, 'resolvedDeadlines', [])]
        .map(item => getDeadlineField(item, 'reviewReason'))
      : reasons),
  ])

  return (
    <section className={`deadline-human-review-banner${calculatedWithReview ? ' is-advisory' : ''}`} role={calculatedWithReview ? 'status' : 'alert'}>
      <div className="deadline-human-review-icon">
        <i className="fas fa-triangle-exclamation" />
      </div>
      <div>
        <h3>{calculatedWithReview ? 'Alerta de revisão' : 'Revisão humana obrigatória'}</h3>
        <p>{calculatedWithReview
          ? 'A ação foi identificada e o prazo foi calculado. A revisão humana continua necessária antes de confirmar o vencimento.'
          : 'Não utilizar como prazo final sem validação jurídica.'}</p>
        {reviewReasons.length ? (
          <ul>
            {reviewReasons.map((reason, index) => <li key={`${reason}-${index}`}>{reason}</li>)}
          </ul>
        ) : (
          <small>O motor marcou a análise para revisão, mas não retornou motivos detalhados.</small>
        )}
      </div>
    </section>
  )
}
